import API from '@aws-amplify/api';
import { selector } from 'recoil';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { getCorporationById } from '@/service/organizationService';
import { getProjectById } from '@/service/projectService';

import { getUserListInProjectByProjectId } from '@/service/userService';
import { projectInuseDetailAtom } from '../atom/projectAtom';
import { userPermissionToViewKnowledgeAtom, getUserListByProjectAtom } from '../atom/userAtom';


/**
 * Get user list by project selector
 * params: projectId, corporationId
 */
export const getUserListByProjectSelector = selector({
    key: 'getUserListByProjectSelector',
    get: async ({ get }) => {
        try {
            let projectInuseDetail = get(projectInuseDetailAtom);
            let userList = await getUserListInProjectByProjectId(API, projectInuseDetail.id);
            
            return userList;
        } catch (err) {
            console.error(`getUserListByProjectSelector error: ${err}`);
            return [];
        }
    },
    set: ({ get, set }, data) => {
        set(getUserListByProjectAtom, data);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});

export const getUserPermissionToViewKnowledgeSelector = selector({
    key: 'getUserPermissionToViewKnowledgeSelector',
    get: async ({ get }) => {
        try {
            const corporationId = localStorageUtil.getAffiliationOrganization();
            const projectInuseId = localStorageUtil.getSelectedProjectId();
            const userId = localStorageUtil.getUserDetailId();

            const [corporationDetail, projectInuseDetail] = await Promise.all([
                getCorporationById(API, corporationId),
                getProjectById(API, projectInuseId)
            ]);

            if (
                !Utils.isEmptyObject(corporationDetail) &&
                !Utils.isEmptyObject(projectInuseDetail)
            ) {
                const userPermissionType = Utils.checkUserPermissionKnowledgeService(
                    corporationDetail,
                    projectInuseDetail
                );

                let knowledgeService = [
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                ].includes(corporationDetail.contractType)
                    ? Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)?.usingKnowledgeService
                    : corporationDetail.knowledgeService;
                return {
                    type: userPermissionType,
                    knowledgeService: knowledgeService,
                    projectSelectedId: projectInuseDetail.id,
                    corporationSelectedId: corporationDetail.id,
                    userId: userId
                };
            }
        } catch (err) {
            console.error(`getUserPermissionToViewKnowledgeSelector error: ${err}`);
            return {};
        }
    },
    set: ({ get, set }, data) => {
        set(userPermissionToViewKnowledgeAtom, data);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});


